import {
  BottomNavigationBar,
  Button,
  Card,
  Layout,
  LazyImage,
  Shape,
  styled,
} from '@teko/ds-mobile';
import { FormInput, OtpInput } from '@teko/ui';

export const StyledBottomNavBar = styled(BottomNavigationBar)`
  display: flex;
  align-items: center;
  padding: 16px 32px;
  height: unset;
`;

export const StyledFormInput = styled(FormInput)`
  margin-bottom: 0.5rem;
`;

export const Status = styled.div(
  ({ success }: { success: boolean }) => `
  color: ${success ? '#4BB543' : '#eb1f3a'};
  margin-bottom: 0.8rem;
`,
);

export const ButtonGroup = styled.div`
  width: 100%;
`;

export const ResendOtpBtn = styled(Button)`
  font-size: 14px;
  line-height: 20px;
  width: max-content;
`;
export const StyledOTPInput = styled(OtpInput)`
  margin: 1rem auto;
  width: 23rem;
  input {
    margin: 0;
  }
`;
export const Center = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledNoti = styled.div`
  color: #eb1f3a;
  text-align: center;
  margin: 1rem auto;
`;

export const StyledRadio = styled.label`
  margin-right: 60px;
  input[type='radio'] {
    margin-right: 5px;
  }
`;

export const BottomSheetContent = styled.div`
  padding: 16px;
  width: 100vw;
`;

export const SubTitleWrapper = styled(Shape)`
  padding-top: 12px;
  padding-left: 16px;
  padding-bottom: 6px;
  text-align: left;
`;

export const Wrapper = styled.div`
  background: white;
  padding: 16px 32px;
`;

export const AvatarArea = styled.div`
  width: 100%;
  background-color: #fff;
  text-align: center;
  padding: 16px 32px 0px 32px;
`;
export const Avatar = styled.div`
  position: relative;
  overflow: hidden;
`;
export const Img = styled(LazyImage)`
  border-radius: 50%;
  width: 100px;
  height: 100px;
  overflow: hidden;
`;

export const StyledLayout = styled(Layout)`
  padding-bottom: calc(env(safe-area-inset-bottom) + 120px);
`;

export const StyledCard = styled(Card)`
  padding: 1rem;
`;
export const PlaceHolderBlock = styled.div`
  width: 100%;
  height: 80vh;
`;
export const StyledInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-top: 0.5rem;
  gap: 0.5rem;
`;
